import {
  AdminInput,
  Button,
  Modal,
  PropsModal,
  SuccessToast,
  rejectVerification,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';
import { useNavigate } from 'react-router';

export const RejectModal = ({
  modalIsOpen,
  closeModal,
  setLoading,
}: PropsModal & {
  modalIsOpen: string | number;
}) => {
  const [reason, setReason] = useState('');
  const navigate = useNavigate();

  const id = modalIsOpen;

  async function handleRejectLocation() {
    try {
      setLoading?.(true);
      const { data } = await rejectVerification(id, reason);
      SuccessToast(data.message);
      closeModal?.();
      navigate(-1);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading?.(false);
    }
  }

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Reject Restaurant"
    >
      <AdminInput
        type="textarea"
        placeholder="Enter rejection reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />

      <Button
        $selected
        $w="100%"
        $mt="40"
        onClick={() => handleRejectLocation()}
      >
        Save
      </Button>
    </Modal>
  );
};
